<template>
	<div class="link-handler">
		<a class="link" :href="url" target="_blank" @click.prevent="handleLink">{{ title }}</a>
		<transition name="bounce" type="animation">
			<PopupWarning
				class="fast-fade fade-enter-active"
				v-if="showPopup"
				:externalUrl="url"
				@close="closePopup"
			/>
		</transition>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PopupWarning from "@/components/abstract/PopupWarning";

export default {
	name: 'SidebarInfoPopup',
	components: {
		PopupWarning,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		url: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			showPopup: false,
		};
	},
	computed: {
		...mapState({
			isBrainPop: state => state.config.general.brain_pop,
		}),
	},
	methods: {
		...mapActions([
			"sendEvent",
		]),
		handleLink() {
			this.linkEvent(this.title);

			if (this.isBrainPop) {
				this.showPopup = true;
			} else {
				window.open(this.url, '_blank');
			}
		},
		closePopup() {
			this.showPopup = false;
		},
		linkEvent(label) {
			this.sendEvent({
				ec: "Game",
				ea: "Info",
				el: label,
			});
		},
	},
};
</script>

<style lang="scss" scoped>
	.link { text-transform: uppercase; }
</style>



// WEBPACK FOOTER //
// src/components/abstract/LinkHandler.vue